import type { IPathBaseParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import type { IFileBasedExamResponse } from "@api/courses/exams/fileBased/types";
import type { IFileBasedExamGetAllParams } from "@api/fileBasedExams/types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IFileBasedExamResponse>>,
  IPathBaseParam,
  IPaginationParams & IFileBasedExamGetAllParams
>("fileBasedExams");

export const fileBasedExams = {
  ...getAllApis,
};
